//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getFormattedTime } from '../../common/dateHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import MessageFileBlock from './MessageFileBlock';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import cx from 'clsx';
// import { format } from 'date-fns';
import _get from 'lodash/get';
// import _set from 'lodash/set';
import _map from 'lodash/map';
import _isNil from 'lodash/isNil';
import _trim from 'lodash/trim';
import _defaultTo from 'lodash/defaultTo';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        //chatRightBlock2In
        root: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0 0 23px 0',
        },
        contentContainerOut: {
            background: '#f1f2f6',
            padding: '12px',
            // fontSize: '16px',
            // lineHeight: '23px',
            borderRadius: '10px',
            wordWrap: 'break-word',
        },
        //chatRightBlock2Inn
        chatRightBlock2MessageContainer: {
            width: '64%',
        },
        attachmentContainer: {
            marginTop: '6px',
        },
        //chatRightBlock2In small
        messageAgeText: {
            marginLeft: '10px',
            fontSize: '13px',
        },
        hidden: {
            display: 'none',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props } = params;
    const { createDt, content, attachment } = props;
    const { contentContainerOut: contentContainerOutCls, attachmentContainer: attachmentContainerCls, hidden: hiddenCls } = classes;

    let createDtText = '';
    if (createDt) {
        createDtText = getFormattedTime(createDt);
    }

    const isEmptyContent = _isNil(content) || _trim(content) === '';

    const defns = {
        contentContainerOut: {
            className: cx(contentContainerOutCls, { [hiddenCls]: attachment && isEmptyContent }),
        },
        attachmentContainer: {
            className: cx(attachmentContainerCls, { [hiddenCls]: !attachment }),
        },
        attachment: {
            attachment,
        },
        messageAgeText: {
            variant: 'caption',
            clsMidGrayColor: true,
            value: createDtText,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MessageBlockOut = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const content = _defaultTo(_get(props, 'content'), '');

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    // Break up the message by newline (if any)
    const getFormattedContent = useCallback(() => {
        const contentSplit = content.split('\n');
        return _map(contentSplit, (str, idx) => {
            const defn = {
                key: `inMessage-${idx}`,
                variant: 'body1',
                clsLightBold: false,
                value: str,
            };
            return <AfitdTypography {...defn} />;
        });
    }, [content]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.chatRightBlock2MessageContainer}>
                <div {...defns.contentContainerOut}>{getFormattedContent(content)}</div>
                <div {...defns.attachmentContainer}>
                    <MessageFileBlock {...defns.attachment} />
                </div>
                <div>
                    <AfitdTypography {...defns.messageAgeText} />
                </div>
            </div>
        </div>
    );
};

export default MessageBlockOut;
